// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highlighted[data-v-878044c8]{background-color:#f1f4ed;padding:10px}.faq-link[data-v-878044c8]{padding-bottom:20px}.faq-question a[data-v-878044c8]:hover{text-decoration:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
